require('./amazonGiftCardImage.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
//@ components
const currencyHelper = require('utilities/currencyHelper');
//@constants
const { EURO_TEXT } = require('constants/index');


class AmazonGiftCardImage extends React.Component {

    render(){
        const { immSteps, accountBuyAmazonGiftCard, isMedium } = this.props;
        let src = (isMedium) ? accountBuyAmazonGiftCard.getIn(['cardImage','fieldImageMedium']) : accountBuyAmazonGiftCard.getIn(['cardImage','fieldImageSmall']);
        let classNameforImg = (isMedium) ? 'amazon-gift-card-image__img-medium' : 'amazon-gift-card-image__img-small'
        let classNameforAmount = (isMedium) ? 'amazon-gift-card-image__amount-medium' : 'amazon-gift-card-image__amount-small'
        const currency = currencyHelper.formatCurrency(EURO_TEXT);
        const amount = immSteps && immSteps.getIn(['0','amount']);

        return(
            <section className="amazon-gift-card-image">
                <img className={`${classNameforImg}`} src={src} />
                <div className="amazon-gift-card-image__amount">
                    <span className={`${classNameforAmount}`}>{currencyHelper.getFormattedString({amount,currency})}</span>
                </div>
            </section>
        );
    }
}

AmazonGiftCardImage.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object,
    immSteps: PropTypes.object,
    isMedium: PropTypes.bool
}

AmazonGiftCardImage.defaultProps = {
    isMedium: false
}

module.exports = AmazonGiftCardImage;
